"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capitalize = void 0;
/** Capitalizes the first letter of a string. */
class Capitalize {
    format(value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}
exports.Capitalize = Capitalize;
//# sourceMappingURL=capitalize.js.map